module.exports = __webpack_public_path__ + "img/timesheet3.c25dfc77.png";